import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
// import Logo from 'ui-component/Logo';
import LogoVaneek from 'assets/images/logo/icon-wide-32.png';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath}>
        <img src={LogoVaneek} alt="vaneek-logo" width="100%" />
    </ButtonBase>
);

export default LogoSection;
